// extracted by mini-css-extract-plugin
module.exports = {"closeIconCross":"ModalCloseIcon-module-close-icon-cross"};